/**
 * Email Subscription Preferences
 * 
 * Enums and types for managing user email subscription preferences.
 * Used across frontend (preference UI) and backend (Lambda functions, DynamoDB).
 */

/**
 * User preference for game reminder email frequency
 */
export enum SubscriptionPreferenceForGameReminders {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  NEVER = 'never',
}

/**
 * User preference for marketing news emails
 */
export enum SubscriptionPreferenceForMarketingNews {
  ALWAYS = 'always',
  NEVER = 'never',
}

/**
 * Email preferences interface for API responses
 */
export interface EmailPreferences {
  subscriptionPreferenceForGameReminders: SubscriptionPreferenceForGameReminders;
  subscriptionPreferenceForMarketingNews: SubscriptionPreferenceForMarketingNews;
}

/**
 * Validate if a string is a valid game reminder preference
 */
export function isValidGameReminderPreference(
  value: string
): value is SubscriptionPreferenceForGameReminders {
  return Object.values(SubscriptionPreferenceForGameReminders).includes(
    value as SubscriptionPreferenceForGameReminders
  );
}

/**
 * Validate if a string is a valid marketing news preference
 */
export function isValidMarketingNewsPreference(
  value: string
): value is SubscriptionPreferenceForMarketingNews {
  return Object.values(SubscriptionPreferenceForMarketingNews).includes(
    value as SubscriptionPreferenceForMarketingNews
  );
}
